import React from 'react';

import { IBaseProps } from '../utils';

import { illustrationPaths } from './IllustrationPaths';

export type IllustrationTypes =
  | 'destruction'
  | 'information'
  | 'success'
  | 'warning'
  | 'app-budget-active'
  | 'app-budget-inactive'
  | 'app-data-active'
  | 'app-data-inactive'
  | 'app-network-active'
  | 'app-network-inactive'
  | 'app-portal-active'
  | 'app-portal-inactive'
  | 'app-reporting-active'
  | 'app-reporting-inactive'
  | 'app-stories-active'
  | 'app-stories-inactive'
  | 'app-si-active'
  | 'app-si-inactive'
  | 'empty-menu-state'
  | 'error-loading'
  | 'empty-panel'
  | 'opengov-logo'
  | 'opengov-logo-wand'
  | 'product-switcher';

export interface IIllustrationProps extends IBaseProps {
  /** Determines illustration displayed, see possible values above. */
  illustration: IllustrationTypes;
  /** Label for screenreaders */
  ariaLabel?: string;
  /** Determines if illustration is hidden to screenreader */
  ariaHidden?: boolean;
  /** Height of the svg */
  height?: number;
  /** Width of the svg */
  width?: number;
  /** color of the svg */
  fill?: string;
}

export const Illustration: React.FC<IIllustrationProps> = ({
  className,
  fill,
  ariaLabel: ariaLabelProp = '',
  ariaHidden = false,
  illustration,
  height = 32,
  width = 32,
  dataTest = 'illustration'
}) => {
  const fallbackIllustration = illustrationPaths.information;

  const path =
    illustrationPaths[illustration] == null ? fallbackIllustration.path : illustrationPaths[illustration].path;
  const viewBox =
    (illustrationPaths[illustration] == null
      ? fallbackIllustration.viewBox
      : illustrationPaths[illustration].viewBox) || '0 0 32 32';
  const ariaLabel =
    illustrationPaths[illustration] == null
      ? fallbackIllustration.ariaLabel
      : illustrationPaths[illustration].ariaLabel;

  return (
    <svg
      className={className}
      viewBox={viewBox}
      aria-hidden={ariaHidden}
      aria-label={ariaLabelProp || ariaLabel}
      width={width}
      height={height}
      data-test={dataTest}
      fill={fill}
    >
      {path}
    </svg>
  );
};
